module.exports = __webpack_public_path__ + "img/c04_unitbowman_Normal_ua.64d1cc4f.webp";